// Paste this file into src/firebase.js
// Replace the FIREBASE_CONFIG object with your Firebase web app config
// from the Firebase console (Project settings -> Your apps -> Config).

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// ---------- PASTE YOUR CONFIG HERE ----------
// Example:
// const FIREBASE_CONFIG = {
//   apiKey: "AIza...",
//   authDomain: "your-project.firebaseapp.com",
//   projectId: "your-project-id",
//   storageBucket: "your-project-id.appspot.com",
//   messagingSenderId: "1234567890",
//   appId: "1:1234567890:web:abcdef",
// };
const FIREBASE_CONFIG = {
  apiKey: "",
  authDomain: "",
  projectId: "",
  storageBucket: "",
  messagingSenderId: "",
  appId: "",
};
// --------------------------------------------

// A simple check to know if user filled config
const isFirebaseConfigured = !!FIREBASE_CONFIG.apiKey;

let firebaseApp = null;
let auth = null;
let db = null;
let storage = null;
let googleProvider = null;

if (isFirebaseConfigured) {
  firebaseApp = initializeApp(FIREBASE_CONFIG);
  auth = getAuth(firebaseApp);
  db = getFirestore(firebaseApp);
  storage = getStorage(firebaseApp);
  googleProvider = new GoogleAuthProvider();
  // Request Drive access to read truck and trailer data
  googleProvider.addScope('https://www.googleapis.com/auth/drive.readonly');
  googleProvider.addScope('https://www.googleapis.com/auth/spreadsheets.readonly');
}

export { firebaseApp, auth, db, storage, googleProvider, isFirebaseConfigured };